var map = {
	"./de/translation.json": [
		9805,
		805
	],
	"./el/translation.json": [
		9219,
		219
	],
	"./en/translation.json": [
		2830,
		830
	],
	"./es/translation.json": [
		6336,
		336
	],
	"./fr/translation.json": [
		5806,
		806
	],
	"./it/translation.json": [
		463,
		463
	],
	"./ja/translation.json": [
		6946,
		946
	],
	"./pl/translation.json": [
		3675,
		675
	],
	"./pt-BR/translation.json": [
		8277,
		277
	],
	"./pt-PT/translation.json": [
		4161,
		161
	],
	"./sv/translation.json": [
		3646,
		646
	],
	"./zh-CN/translation.json": [
		4314,
		314
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 471;
module.exports = webpackAsyncContext;